<template>
  <div>

        <commonheader :activeNavIdx="1"></commonheader>
        <el-container class="el-container-master">
            <div class="content">
                <div class="crumbsNavCont">
                    <p class="crumbsNav">位置：首页>协会介绍</p>
                </div>
                <div class="associationIntroduceCont">
                    <div class="introducePort">
                        <div class="introducePortTitle">
                            <h2>协会简介</h2>
                            <span class="introducePortTitleEnglish">Association Brief</span>
                        </div>
                        <div class="xiehuijianjieList">
                            <!-- <p>湖南省药师协会Hunan Pharmacist Association（HNPA）是由湖南省具有药学专业技术职务或执业资格的药学技术人员及相关单位会员自愿发起成立的专业性、非营利性社会组织。协会的宗旨是：遵守国家宪法、法律、法规和国家政策，遵守社会道德风尚。致力于加强药学技术人员队伍建设与自律管理，规范执业行为；维护药学技术人员的合法权益；增强药学技术人员的法律、道德和专业素质，提高执业能力，促进药学技术繁荣发展；保证药品质量和药学服务质量，保证公众用药安全、有效、经济、合理，为全省医药卫生事业发展和人民群众健康服务。是党和政府联系药学科学技术工作者的桥梁和纽带，是湖南省发展药学科学技术事业的重要社会力量。本协会接受社团登记管理机关湖南省民政厅的业务指导和监督管理。</p> -->
                            <p>湖南省药师协会（Hunan Pharmacist Association, HNPA）是湖南省药学技术工作者及相关单位会员自愿组成并依法成立的具有学术性、公益性、非营利性的法人社会团体，成立于2009年。</p>
                            <p>本协会遵守国家宪法、法律、法规、政策，遵循社会道德风尚，是党和政府联系药学科学技术工作者的桥梁和纽带，是湖南省发展药学科学技术事业的重要社会力量。本协会接受社团登记管理机关湖南省民政厅的业务指导和监督管理。</p>
                            <p>本协会致力于加强药学技术人员队伍建设与自律管理，规范执业行为；维护药学技术人员的合法权益；增强药学技术人员的法律、道德和专业素质，提高执业能力，促进药学技术繁荣发展；保证药品质量和药学服务质量，保证公众用药安全、有效、经济、合理，为全省医药卫生事业发展和人民群众健康服务。</p>
                        </div>

                        <div class="xiehuijianjieOtherCont">
                            <ul class="xiehuijianjieOtherListLeft fl">
                                <li><span>积极贯彻执行党和政府关于医药卫生方针、政策，贯彻国家有关药师管理和药品监督管理等方面的法律、法规和政策，宣传药品质量与安全意识，努力服务于人民，服务于社会。</span></li>
                                <li><span>履行团体职责，加强药师的自律管理，规范药师执业行为，维护药师合法权益。</span></li>
                                <li><span>开展与药师相关的培训服务及继续教育，加强药师队伍建设，提高药师的执业能力。</span></li>
                                <li><span>组织开展与药师、执业药师相关的药学方面的研究工作。</span></li>
                                <li><span>接受政府主管部门委托，参与有关药师管理法规、规章的制定；承担有关药学学术发展、药品合理使用及监管等方面的任务和项目。</span></li>
                            </ul>

                            <ul class="xiehuijianjieOtherListRight fl">
                                <li><span>开展学术交流，活跃学术思想，传递科学信息，组织科学考察，促进科学发展，密切学科间和学术团体间的横向联系和协作。开展与其他药学科学学术团体和药学科学技术工作者的学术联系和交往。</span></li>
                                <li><span>介绍、推广药学新理论、新知识、新技术、新方法，促进药学技术的发展和进步。</span></li>
                                <li><span>反映会员和药学工作者的意见和建议，维护会员和药学工作者的合法权益；积极探索建立和完善药学科学研究诚信监督机制，促进药学科学道德建设和民主学风建设。</span></li>
                                <li><span>建立并完善湖南省药师协会官网、官微等宣传平台，依照有关规定编辑出版学术刊物和科普资料，宣传和咨询合理用药的知识，向药学人员及公众提供药学信息和健康知识服务。</span></li>
                                <li><span>根据有关规定，表彰、奖励在生产、经营、使用、教育、科研中为推动合理用药、保障公众健康做出突出贡献的与药师相关的人员。</span></li>
                            </ul>


                        </div>
                    </div>
                    <div class="introducePort">
                        <div class="introducePortTitle associationArticlesTitle">
                            <h2>协会章程</h2>
                            <span class="introducePortTitleEnglish">Association of Association</span>
                        </div>
                        <div class="associationArticles">
                            <div class="associationArticlesList">
                                <p class="associationArticlesListTitle">第一章 总则</p>
                                <ul class="associationArticlesListItem">
                                    <li><span class="tiaoshuTitle">第一条</span>本协会的名称：湖南省药师协会；英文译名：Hunan Pharmacist Association，英文缩写：HNPA。</li>
                                    <li><span class="tiaoshuTitle">第二条</span>本协会是依法设立的社会团体法人，由湖南省具有药学专业技术职务或执业资格的药学技术人员及相关单位自愿发起成立的自律性、专业性、非营利性社会组织。</li>
                                    <li><span class="tiaoshuTitle">第三条</span>本协会的宗旨是：坚持中国共产党的全面领导，根据中国共产党章程的规定，设立中国共产党的组织，开展党的活动，为党组织的活动提供必要条件；致力于加强药学技术人员队伍建设与自律管理，规范执业行为；维护药学技术人员的合法权益；增强药学技术人员的法律、道德和专业素质，提高执业能力，促进药学技术繁荣发展；保证药品质量和药学服务质量，保证公众用药安全、有效、经济、合理，为全省医药卫生事业发展和人民群众健康服务；是党和政府联系药学科学技术工作者的桥梁和纽带，是湖南省发展药学科学技术事业的重要社会力量。本协会遵守宪法、法律、法规和国家政策，践行社会主义核心价值观，弘扬爱国主义精神，遵守社会道德风尚，自觉加强诚信自律建设。</li>
                                    <li><span class="tiaoshuTitle">第四条</span>本协会登记管理机关是湖南省民政厅，党建领导机关是中共湖南省非公有制经济组织综合委员会。本协会接受社团登记管理机关、党建领导机关、有关行业管理部门的业务指导和监督管理。</li>
                                    <li><span class="tiaoshuTitle">第五条</span>本协会住所：湖南省长沙市。</li>
                                </ul>
                            </div>

                            <div class="associationArticlesList">
                                <p class="associationArticlesListTitle">第二章 业务范围</p>
                                <ul class="associationArticlesListItem">
                                    <li><span class="tiaoshuTitle">第六条</span>本协会业务范围：普法、自律、维权、教育、协调、服务。</li>
                                    <li>（一）积极贯彻执行党和政府关于医药卫生方针、政策，贯彻国家有关药师管理和药品监督管理等方面的法律、法规和政策。宣传药品质量与安全意识，努力服务于人民，服务于社会；</li>
                                    <li>（二）履行团体职责，加强药师的自律管理，规范药师执业行为，维护药师合法权益；</li>
                                    <li>（三）开展与药师相关的培训服务及继续教育，加强药师队伍建设，提高药师的执业能力；</li>
                                    <li>（四）组织开展与药师相关的药学方面的研究工作；</li>
                                    <li>（五）接受政府主管部门委托，参与有关药师管理法规、规章的制定；承担有关药学学术发展、药品合理使用及监管等方面的任务和项目；</li>
                                    <li>（六）开展学术交流，活跃学术思想，传递科学信息，组织科学考察，促进科学发展，密切学科间和学术团体间的横向联系和协作。开展与其它药学科学学术团体和药学科学技术工作者的学术联系和交往。</li>
                                    <li>（七）介绍、推广药学新理论、新知识、新技术、新方法，促进药学技术的发展和进步；</li>
                                    <li>（八）反映会员和药学工作者的意见和建议，维护会员和药学工作者的合法权益；积极探索建立和完善药学科学研究诚信监督机制，促进药学科学道德建设和民主学风建设；</li>
                                    <li>（九）建立湖南省药师协会官网、官微等宣传平台，依照有关规定编辑出版学术刊物和科普资料，宣传和咨询合理用药的知识，向药学人员及公众提供药学信息和健康知识服务；</li>
                                    <li>（十）根据有关规定，表彰、奖励在生产、经营、使用、教育、科研中为推动合理用药、保障公众健康做出突出贡献的药师及相关人员。</li>
                                </ul>
                            </div>

                            <div class="associationArticlesList">
                                <p class="associationArticlesListTitle">第三章 会员</p>
                                <ul class="associationArticlesListItem">
                                    <li><span class="tiaoshuTitle">第七条</span>本协会会员分为个人会员和单位会员。</li>
                                    <li><span class="tiaoshuTitle">第八条</span>申请参加本协会的，必须具备下列条件：</li>
                                    <li>个人会员：</li>

                                    <li>（一）拥护本协会的章程； </li>
                                    <li>（二）有加入本协会的意愿； </li>
                                    <li>（三）在药品生产、经营、使用、教育、科研单位或相关团体具有药学专业技术职务或执业资格的药学技术人员及管理工作者；</li>
                                    <li>（四）履行会员权利和义务，热心于医药事业发展。</li>
                                    <li>团体会员：</li>
                                    <li>（一）拥护本协会的章程； </li>
                                    <li>（二）有加入本协会的意愿；</li>
                                    <li>（三）从事药品使用、经营、生产、教育、科研相关活动，具有独立法人资格的企事业单位、社会组织；</li>
                                    <li>（四）履行会员权利和义务，热心于医药事业发展。</li>
                                    <li><span class="tiaoshuTitle">第九条</span> 会员入会程序：</li>
                                    <li>（一） 提交入会申请； </li>
                                    <li>（二） 经理事会或理事会授权的机构审查通过； </li>
                                    <li>（三） 由理事会或理事会授权的机构发给会员证。</li>
                                    <li><span class="tiaoshuTitle">第十条</span> 会员享有下列权利：</li>
                                    <li>（一）本协会的选举权、被选举权和表决权； 
                                    <li>（二）参加本协会的活动； </li>
                                    <li>（三）获得本协会服务的优先权；</li>
                                    <li>（四）对协会工作的批评建议和监督权；</li>
                                    <li>（五）个人会员可免费参加协会组织的继续教育培训； </li>
                                    <li>（六）入会自愿、退会自由。</li>
                                    <li><span class="tiaoshuTitle">第十一条</span> 会员履行下列义务：</li>
                                    <li>（一）执行本协会的决议； </li>
                                    <li>（二）维护本协会的合法权益； </li>
                                    <li>（三）完成本协会交办的工作；</li>
                                    <li>（四）按规定缴纳会费； </li>
                                    <li>（五）积极参加本协会组织的活动； </li>
                                    <li>（六）向本协会提供有关资料，及时反映情况。</li>
                                    <li><span class="tiaoshuTitle">第十二条</span> 单位会员连续两年不交纳会费或不参加本协会活动的，个人会员连续两年不参加本协会活动或不参加本协会组织的继续教育培训且未能按时取得年度继续教育学分的，视为自动退会。</li>
                                    <li><span class="tiaoshuTitle">第十三条</span> 会员如有严重违反本章程的行为，经理事会或常务理事会表决通过，予以除名。</li>
                                </ul>
                            </div>

                            <div class="associationArticlesList">
                                <p class="associationArticlesListTitle">第四章 组织机构和负责人产生、罢免</p>
                                <ul class="associationArticlesListItem">
                                    <li><span class="tiaoshuTitle">第十四条</span>本协会的最高权力机构是会员代表大会，会员代表大会的职权是：</li>
                                    <li>（一）制定或修改章程； </li>
                                    <li>（二）选举或罢免理事、监事； </li>
                                    <li>（三）审议理事会的工作报告和财务报告；</li>
                                    <li>（四）审议监事会的工作报告；</li>
                                    <li>（五）决定名誉职务的设立；</li>
                                    <li>（六）决定终止事宜；</li>
                                    <li>（七）决定其他重大事宜。</li>
                                    <li><span class="tiaoshuTitle">第十五条</span> 会员代表大会须有2/3以上的会员代表出席方能召开，其决议须经到会会员代表半数以上表决通过方能生效。</li>
                                    <li><span class="tiaoshuTitle">第十六条</span> 会员代表大会每届5年。因特殊情况需提前或延期换届的，须由理事会表决通过，经社团登记管理机关批准同意。但延期换届最长不超过1年。</li>
                                    <li><span class="tiaoshuTitle">第十七条</span> 本协会按照有关规定，根据协会工作需要和中国共产党党员数量，设立中国共产党的组织机构，从而发挥党组织对本协会会员及药学技术人员的政治引领和政治吸纳作用，把广大药学技术人员紧紧凝聚在中国共产党的周围。</li>
                                    <li><span class="tiaoshuTitle">第十八条</span> 理事会是会员代表大会的执行机构，在闭会期间领导本协会开展日常工作，对会员代表大会负责。</li>
                                    <li><span class="tiaoshuTitle">第十九条</span> 理事会的职责是：</li>
                                    <li>（一）执行会员代表大会的决议；</li>
                                    <li>（二）选举或罢免会长、副会长、常务理事、秘书长；</li>
                                    <li>（三）决定名誉职务的人选；</li>
                                    <li>（四）筹备召开会员代表大会；</li>
                                    <li>（五）向会员代表大会报告工作和财务状况；</li>
                                    <li>（六）决定会员的吸收或除名；</li>
                                    <li>（七）向会员代表大会提请增补或更换理事；</li>
                                    <li>（八）决定设立办事机构、分支机构、代表机构和实体机构；</li>
                                    <li>（九）决定副秘书长、各机构主要负责人的聘任或解聘；</li>
                                    <li>（十）领导本协会各机构开展工作；</li>
                                    <li>（十一）制定内部管理制度；</li>
                                    <li>（十二）决定其他重大事项。</li>

                                    <!-- <li>（一）执行会员大会(或会员代表大会)的决议； （二）选举和罢免会长、副会长、秘书长； （三） 筹备召开会员大会(或会员代表大会)；</li>
                                    <li>（四）按规定缴纳会费（会费标准为:执行会长单位3万元/年；副会长单位1万元/年；常务理事单位5千元/年；理事单位1千元/年；个人会员150元/年）。</li>
                                    <li>（七）决定副秘书长、各机构主要负责人的聘任或解聘； （八）领导本协会各机构开展工作； （九） 制定内部管理制度；</li>
                                    <li>（十）决定其他重大事项。</li> -->
                                    <li><span class="tiaoshuTitle">第二十条</span>理事会须有2/3以上理事出席方能召开，其决议须经到会理事2/3以上表决通过方能生效。</li>
                                    <li><span class="tiaoshuTitle">第二十一条</span>理事会每年至少召开一次会议；情况特殊的，也可采用通讯形式召开。理事连续两次不参加理事会会议或会员代表大会的，视为职务自动取消。</li>
                                    <li><span class="tiaoshuTitle">第二十二条</span>本协会设立常务理事会。常务理事会由理事会选举产生，在理事会闭会期间行使第十九条第一、四、六、八、九、十、十一项的职权，对理事会负责。</li>
                                    <li><span class="tiaoshuTitle">第二十三条</span>常务理事会须有2/3以上常务理事出席方能召开，其决议须经到会常务理事2/3以上表决通过方能生效。</li>
                                    <li><span class="tiaoshuTitle">第二十四条</span>常务理事会至少半年召开一次会议；情况特殊的也可采用通讯形式召开。常务理事连续两次不参加常务理事会会议、理事会会议或会员代表大会的，视为职务自动取消。</li>
                                    <li><span class="tiaoshuTitle">第二十五条</span>本协会的会长、副会长、监事长、秘书长必须具备下列条件：</li>
                                    <li>（一）坚持党的路线、方针、政策，政治素质好； </li>
                                    <li>（二）在本协会业务领域内有较大影响； </li>
                                    <li>（三）会长、副会长、监事长最高任职年龄不超过70周岁；秘书长为专职，最高任职年龄不超过65周岁；</li>
                                    <li>（四）身体健康，能坚持正常工作；</li>
                                    <li>（五）未受过剥夺政治权利的刑事处罚；</li>
                                    <li>（六）具有完全民事行为能力。</li>
                                    <li><span class="tiaoshuTitle">第二十六条</span>本协会会长、副会长、监事长、秘书长如超过最高任职年龄的，须经理事会表决通过，经社团登记管理机关批准同意后，方可任职。</li>
                                    <li><span class="tiaoshuTitle">第二十七条</span>本协会会长、副会长、监事长、秘书长任期五年。会长、副会长、监事长、秘书长任期最长不得超过两届，因特殊情况需延长任期的，须经会员代表大会2/3以上会员代表表决通过，并经社团登记管理机关批准同意后方可任职。</li>
                                    <li><span class="tiaoshuTitle">第二十八条</span>本协会法定代表人由会长或秘书长担任。本协会法定代表人不兼任其他团体的法定代表人。</li>
                                    <li><span class="tiaoshuTitle">第二十九条</span>本协会会长行使下列职权：</li>
                                    <li>（一）召集和主持理事会会议、常务理事会会议、会长办公会； </li>
                                    <li>（二）督促会员代表大会、理事会会议、常务理事会会议、会长办公会决议、的落实； </li>
                                    <li>（三）代表本协会签署有关重要文件；</li>
                                    <li>（四）提名秘书长人选，交理事会决定。</li>
                                    <li>会长因故不能履行职权，由会长委派或常务理事会指定副会长代行职权。</li>
                                    <li><span class="tiaoshuTitle">第三十条</span>会长办公会由会长召集并主持召开。会长可授权协会其他领导主持召开。</li>
                                    <li>会长办公会参加人员为：会长、副会长、秘书长、监事长。其中，副会长参会范围根据会议议题内容确定。</li>
                                    <li>会长办公会根据工作需要召开。特殊情况下，会议可以通讯形式（包括但不限于视频会议、电话会议）召开。</li>
                                    <li><span class="tiaoshuTitle">第三十一条</span> 会长办公会议事内容包括：</li>
                                    <li>（一）贯彻落实党的路线方针政策、党和国家重要法律法规以及主管部门、业务指导部门对社会组织的相关规定、重要工作部署的意见和措施；</li>
                                    <li>（二）协会改革发展方面的重大事项，协会中长期规划、年度工作计划的编制；</li>
                                    <li>（三）对理事会换届方案以及分支机构成立、合并、撤销事宜提出意见；</li>
                                    <li>（四）对协会副秘书长以上人选以及分支机构主要负责人的调整、任免事项提出意见；</li>
                                    <li>（五）对提交会员代表大会或理事会（常务理事会）审议的工作报告、年度财务预算、决算报告等提出意见；</li>
                                    <li>（六）协会加强党的建设、党风廉政建设和反腐败工作等方面的重要事项；</li>
                                    <li>（七）协会规章制度的建立、修改、废止等方面的事项；</li>
                                    <li>（八）协会重要业务活动、特殊专项工作以及重大涉外活动的审议；</li>
                                    <li>（九）20万元以上预算外经费开支、资产采购与处置以及对外投资、合作项目；</li>
                                    <li>（十）协会业务领域创先评优和重大奖惩、授予荣誉等事宜的审议；
                                    <li>（十一）其他需要会长办公会集体研究的事项。</li>
                                    <li>会长办公会讨论的事项意见不能相对集中的情况下，可提交理事会会议最终决定。</li>
                                    <li><span class="tiaoshuTitle">第三十二条</span>本协会秘书长行使下列职权：</li>
                                    <li>（一）落实会员代表大会、理事会、常务理事会、会长办公会的决议； </li>
                                    <li>（二）主持办事机构开展日常工作，组织实施年度工作计划；</li>
                                    <li>（三）协调各分支机构、代表机构、实体机构开展工作； </li>
                                    <li>（四）提名副秘书长以及各分支机构、代表机构、实体机构主要负责人，交理事会、常务理事会、会长办公会决定；</li>
                                    <li>（五）决定办事机构、代表机构、实体机构专职工作人员的聘用或解聘； </li>
                                    <li>（六）处理其他日常事务。</li>
                                    <li><span class="tiaoshuTitle">第三十三条</span>本协会可以设置名誉会长、名誉副会长、专家顾问等名誉职务。名誉职务任期最长不得超过两届。</li>
                                    <li><span class="tiaoshuTitle">第三十四条</span>本协会设监事会，监事会由会员代表大会选举产生，对会员代表大会负责。</li>
                                    <li><span class="tiaoshuTitle">第三十五条</span>监事应从具有良好职业道德和较高业务水平，业内声誉良好，具有奉献精神，热心于医药卫生事业发展的会员代表中选举产生。监事可连选连任，但连任不得超过两届。理事、常务理事、副会长、会长不得兼任监事。</li>
                                    <li><span class="tiaoshuTitle">第三十六条</span>监事会的职权是：</li>
                                    <li>（一）监督理事会、常务理事会执行会员代表大会决议的情况，遵守本协会章程以及各项规章制度的情况；</li>
                                    <li>（二）监督会长办公会、秘书处、会长、副会长和秘书长履行职责的情况，遵守本协会章程以及各项规章制度的情况；</li>
                                    <li>（三）监督预算执行及重大事项的财务收支情况；</li>
                                    <li>（四）提请临时召开会员代表大会、理事会会议、常务理事会会议；</li>
                                    <li>（五）接受会员代表对理事会、常务理事会、秘书处的情况反映；</li>
                                    <li>（六）会员代表大会授予的其他职权。</li>
                                    <li><span class="tiaoshuTitle">第三十七条</span>监事会可通过下列方式行使监督权：</li>
                                    <li>（一）列席理事会会议；</li>
                                    <li>（二）对监督事项提出建议、异议或提案；</li>
                                    <li>（三）聘请专业的审计机构，对预算执行情况、决算以及重大事项的财务收支情况进行审计；</li>
                                    <li>（四）提议临时召开会员代表大会、理事会会议、常务理事会会议；</li>
                                    <li>（五）其他方式。</li>
                                    <li><span class="tiaoshuTitle">第三十八条</span>监事会由三至五名监事组成，并设监事长一名，由监事会全体成员以超过半数通过选举产生。</li>
                                    <li>监事长行使下列职权：</li>
                                    <li>（一）召集并主持监事会会议；</li>
                                    <li>（二）列席或委派监事列席常务理事会会议、会长办公会；</li>
                                    <li>（三）代表监事会向会员代表大会报告工作；</li>
                                    <li>（四）督促、检查监事会决议的执行情况。</li>
                                    <li><span class="tiaoshuTitle">第三十九条</span>监事会会议必须有全体监事的2/3以上出席方可举行。监事会会议形成决议，须经全体监事的半数以上通过方为有效。</li>
                                    <li><span class="tiaoshuTitle">第四十条</span>监事会会议由监事长召集并主持，监事长因特殊原因不能履行职务时，由监事长指定的监事代表召集并主持。</li>
                                    <li><span class="tiaoshuTitle">第四十一条</span>专业委员会</li>
                                    <li>根据专业发展需要，本协会下设若干专业委员会，由理事会或常务理事会讨论决定设立、撤销。</li>
                                    <li><span class="tiaoshuTitle">第四十二条</span>理事、常务理事、监事因工作变动不再从事医药卫生工作或不再代表原机构单位的，应当在一个月内提出申请辞去理事、常务理事、监事职务。未在规定期限内提出申请的，其理事、常务理事、监事职务自动取消。</li>
                                    <li>理事、常务理事、监事届内连续两次不履行职责的，其理事、常务理事、监事职务自动取消。</li>
                                    <li>会长、副会长、监事长届内连续三次不履行职责的，其会长、副会长、监事长职务自动取消。</li>
                                    <li><span class="tiaoshuTitle">第四十三条</span>理事、常务理事、副会长、会长、监事、监事长作为本协会权力机构、监督机构的组成人员，应当诚实守信，勤勉尽职，以身作则，模范执行法律、法规和本协会的规章制度，维护本协会及本行业的整体利益，接受代表对其履行职责的监督和合理建议。</li>
                                   
                                </ul>
                            </div>



                            <div class="associationArticlesList">
                                <p class="associationArticlesListTitle">第五章 资产管理、使用原则</p>
                                <ul class="associationArticlesListItem">
                                    <li><span class="tiaoshuTitle">第四十四条</span>本协会经费来源：</li>
                                    <li>（一）会费收入；</li>
                                    <li>（二）业务活动收入；</li>
                                    <li>（三）政府部门或其他部门对协会的经费资助及委托项目服务费收入；</li>
                                    <li>（四）社会捐赠；</li>
                                    <li>（五）其他合法收入。</li>
                                    <li><span class="tiaoshuTitle">第四十五条</span>本协会按照国家有关规定收取会费。协会注册资金已由会费解决。</li>
                                    <li><span class="tiaoshuTitle">第四十六条</span>本协会经费必须用于本章程规定的业务范围和事业发展，不得在会员中分配。</li>
                                    <li><span class="tiaoshuTitle">第四十七条</span>本协会建立严格的财务管理制度，保证会计资料合法、真实、准确、完整。</li>
                                    <li><span class="tiaoshuTitle">第四十八条</span>本协会配备具有专业资格的会计人员。会计不得兼任出纳。会计人员必须进行会计核算，实行会计监督。会计人员调动工作或离职时，必须与接管人办清交接手续。</li>
                                    <li><span class="tiaoshuTitle">第四十九条</span>本协会的资产管理必须执行国家规定的财务管理制度，接受会员代表大会和财政部门的监督。资产来源属于国家拨款或者社会捐赠、资助的，必须接受审计机关的监督，并将有关情况以适当方式向社会公布。</li>
                                    <li><span class="tiaoshuTitle">第五十条</span>本协会换届或更换法定代表人之前必须接受社团登记管理机关组织的财务审计。</li>
                                    <li><span class="tiaoshuTitle">第五十一条</span>本协会的资产，任何单位、个人不得侵占、私分和挪用。</li>
                                    <li><span class="tiaoshuTitle">第五十二条</span>本协会专职工作人员的工资和保险、福利待遇，参照国家对事业单位的有关规定执行。</li>
                                    
                                </ul>
                            </div>


                            <div class="associationArticlesList">
                                <p class="associationArticlesListTitle">第六章 章程的修改程序</p>
                                <ul class="associationArticlesListItem">
                                    <li><span class="tiaoshuTitle">第五十三条</span>对本协会章程的修改，须经理事会表决通过后报会员代表大会审议。</li>
                                    <li><span class="tiaoshuTitle">第五十四条</span>本协会修改的章程，须经会员代表大会审议通过，并报社团登记管理机关核准后生效。</li>
                                   
                                </ul>
                            </div>


                            <div class="associationArticlesList">
                                <p class="associationArticlesListTitle"> 第七章 终止程序及终止后的财产处理</p>
                                <ul class="associationArticlesListItem">
                                   <li><span class="tiaoshuTitle">第五十五条</span>本协会完成宗旨或自行解散或由于分立、合并等原因需要注销的，由理事会或常务理事会提出终止动议。</li>
                                   <li><span class="tiaoshuTitle">第五十六条</span>本协会终止动议须经会员代表大会表决通过。</li>
                                   <li><span class="tiaoshuTitle">第五十七条</span>本协会终止前，须在有关机关指导下成立清算组织，清理债权债务，处理善后事宜。清算期间，不开展清算以外的活动。</li>
                                   <li><span class="tiaoshuTitle">第五十八条</span>本协会经社团登记管理机关办理注销登记手续后即为终止。</li>
                                   <li><span class="tiaoshuTitle">第五十九条</span>本协会终止后的剩余财产，在社团登记管理机关的监督下，按照国家有关规定，用于发展与本协会宗旨相关的事业。</li>
                                </ul>
                            </div>

                            <div class="associationArticlesList">
                                <p class="associationArticlesListTitle"> 第八章 附则</p>
                                <ul class="associationArticlesListItem">
                                    <li><span class="tiaoshuTitle">第六十条</span> 本章程于经2022年6月10日湖南省药师协会三届二次会员代表大会表决通过。</li>
                                    <li><span class="tiaoshuTitle">第六十一条 </span> 本章程的解释权属本协会理事会。</li>
                                    <li><span class="tiaoshuTitle">第六十二条 </span> 本章程自社团登记管理机关核准之日起生效。</li>
                                </ul>
                            </div>


                        </div>

                    </div>


                    <!-- <div class="introducePort">
                        <div class="introducePortTitle">
                            <h2>会员须知</h2>
                            <span class="introducePortTitleEnglish">Members' notice</span>
                        </div>


                        <div class="noticeToMembersCont">
                            <ul class="noticeToMembersLeft fl">
                                <ul class="noticeToMembersLeftList">
                                    <li>
                                        <p class="noticeToMembersListTitle">入会条件</p>
                                        <div class="noticeToMembersListDetail">
                                            <p>个人会员须是已经取得执业药师、从业药师资格或在药品生产、经营、使用、教育、科研、管理等 部门工作的药学技术人员。</p>
                                        </div>
                                    </li>
                                    <li>
                                        <p class="noticeToMembersListTitle">入会费用</p>
                                        <div class="noticeToMembersListDetail">
                                            <p>会员费：210元/人/年，每年1月1日开始征缴当年会员费。</p>
                                        </div>
                                    </li>
                                </ul>
                            </ul>
                            <ul class="noticeToMembersMiddle fl">
                                <ul class="noticeToMembersRightList">
                                    <li>
                                        <p class="noticeToMembersListTitle">入会办法</p>
                                        <div class="noticeToMembersListDetail">
                                            <p>1.网上注册(点击首页右上侧"会员登陆"注册，按步骤填写相应表格<br>2.协会审核后，发送会员卡。</p>
                                        </div>
                                    </li>
                                <li>
                                        <p class="noticeToMembersListTitle">交费方法</p>
                                        <div class="noticeToMembersListDetail">
                                            <p>通过网银支付【注意：汇款时，请在附言栏注明姓名和用途】。</p>
                                        </div>
                                    </li>

                                </ul>
                            </ul>
                            <ul class="noticeToMembersRight fl">
                                <ul class="noticeToMembersMiddleList">
                                    <li>
                                        <p class="noticeToMembersListTitle">应有义务</p>

                                        <div class="noticeToMembersListDetail">
                                            <p>1.遵守本协会章程、执行本协会的决议；<br>2.维护本协会的合法权益和声誉；<br>3.积极参与本协会的活动，完成本协会委托的各项工作；<br>4.按期缴纳会费。</p>
                                        </div>
                                    </li>




                                    <li>
                                        <p class="noticeToMembersListTitle">特别提醒</p>
                                        <div class="noticeToMembersListDetail">
                                            <p>1.变更工作单位和联系地址等，应及时上网申请变更（登陆协会会员窗口，修改资料）。<br>2.协会的联系电话0731-88635922 传真88635924。<br>3.会员证请与身份证同时使用。</p>
                                        </div>
                                    </li>
                                </ul>
                            </ul>


                        </div>

                        <div class="accesToServices">
                            <h2>享有服务</h2>
                            <p>1.本协会的选举权、被选权和表决权； 2.对本协会工作的批评建议权和监督权； 3.入会自愿、退会自由；</p>
                            <p>4.优惠或免费参加本协会学术年会、学术讲座等交流活动，并获得相应学分； 5.享受继续教育培训、注册指导等专享服务；</p>
                            <p>6.免费在湖南省药师协会网上刊登招聘或求职信息，咨询相关法规等； 7.会员享有的其他权利。</p>
                        </div>
                    </div>             -->

                </div>
            </div>



        </el-container>
        <commonfooter></commonfooter>



  </div>
</template>

<script>

import commonheader from './common/commonHeader.vue' //头部组件
import commonfooter from './common/commonFooter.vue' //底部组件

export default {
  name: "index",
  components: {
    commonheader,
    commonfooter,
  },
  data() {
    return {




    };
  },
  mounted() {

  },
  methods: {

  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

@media (min-width: 1399px) {
    .el-container-master {
        width: 1200px;
        margin: auto;
    }

}
.el-container-master {
  flex-direction: column
}

.content {
  /* width:1400px;
  margin: 0 auto; */
  padding-bottom:50px;
}
.crumbsNavCont {
    height:70px;
    position: relative;
}
.crumbsNav {
    font-size:14px;
    color:#222;
    height:100%;
    line-height: 70px;
}

.associationNewDetailCont {

}

.detailTitle {
    text-align: center;
    margin-top:25px;
    font-weight: bold;
    width:70%;
    margin:25px auto 0;
}

.publishTime {
    text-align: center;
    color:#999;
    font-size:14px;
    margin-top:20px;
}

.paragraphList {
    width:1000px;
    margin:0 auto;
}

.paragraphList>p {
    margin-top:35px;
    font-size:16px;
    color:#333;
    line-height: 32px;
    text-indent: 10px;
}
.paragraphList>p>img {
    display:block;
    max-width: 700px;
    margin:0 auto;
}

.introducePort {
    margin-top:50px;
}
.introducePort:first-child{
    margin-top:0;
}
.introducePortTitle {
    position: relative;
    margin-bottom:50px;

}



.introducePortTitle h2 {
    font-size:36px;
    font-weight: normal;
    color:#0173FF;
    text-align: center;
    background:url('../assets/images/xiehuijieshao_icon.png') no-repeat 40% center;
    background-size:53px auto;
}



.introducePortTitleEnglish  {
    position:absolute;
    left:57%;
    top:20px;
    color:#0173FF;
    font-size:18px;


}

.xiehuijianjieList p{
    color:#333;
    line-height: 32px;
    text-indent: 40px;
}

.xiehuijianjieOtherCont {
    width:1200px;
    margin:50px auto 0;
    height: 500px;
}

.xiehuijianjieOtherListLeft, .xiehuijianjieOtherListRight {
    width:600px;
}

.xiehuijianjieOtherListLeft  {
    -moz-box-shadow: -2px -2px 1px rgba(179,179,179, -0.4);
    box-shadow: -2px -2px 1px rgba(179,179,179,-0.4);
    box-shadow: -2px -2px 1px rgba(179,179,179, -0.4);
}

.xiehuijianjieOtherListRight  {
    -moz-box-shadow: 2px 2px 1px rgba(179,179,179, -0.4);
    box-shadow: 2px 2px 1px rgba(179,179,179,-0.4);
    box-shadow: 2px 2px 1px rgba(179,179,179, -0.4);
}

.xiehuijianjieOtherListLeft li, .xiehuijianjieOtherListRight li {
    width:100%;
    height: 100px;
    line-height: 22px;
    color:#333;
    padding:20px;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    position: relative;
}
.xiehuijianjieOtherListRight .red{
    color: red;
}
.xiehuijianjieOtherListLeft li span, .xiehuijianjieOtherListRight li span {
    position:absolute;
    top:50%;
    transform:translateY(-50%);
    padding-right:20px;
}
.xiehuijianjieOtherListLeft li:nth-child(even) {
    background:rgba(248,248,248,1);
    box-shadow:0px 2px 4px 0px rgba(179,179,179,0.5);
}

.xiehuijianjieOtherListLeft li:nth-child(odd) {
    background:rgba(255,255,255,1);
    box-shadow:-1px 0px 4px 0px rgba(166,166,166,0.5);
}

.xiehuijianjieOtherListRight li:nth-child(odd) {
    background:rgba(248,248,248,1);
    box-shadow:0px 2px 4px 0px rgba(179,179,179,0.5);
}

.xiehuijianjieOtherListRight li:nth-child(even) {
    background:rgba(255,255,255,1);
    box-shadow:-1px 0px 4px 0px rgba(166,166,166,0.5);
}


.associationArticles {
    margin-top:50px;
}
.associationArticlesList {

}

.associationArticlesListTitle {
    font-size:18px;
    color:#333;
    text-align: center;
    font-weight: bold;
    margin-top:50px;
}

.associationArticlesListItem {
    margin-top:30px;
}

.associationArticlesListItem li {
    color:#333;
    font-size:16px;
    line-height: 32px;
    margin-bottom:20px;
}
.associationArticlesListItem li .tiaoshuTitle {
    font-weight: bold;
    margin-right: 10px;
}

.noticeToMembersCont {
    height:616px;
}
.noticeToMembersCont>ul {
    width:33.33%;
}


.noticeToMembersCont>ul>ul li {
    padding:45px 25px 30px;
    height: 308px;
    box-sizing:border-box;
    -moz-box-sizing: border-box;
}

.noticeToMembersListTitle {
    font-size:26px;
    color:#333;
    text-align: center;

}
.noticeToMembersListDetail {
    height:81%;
    position: relative;
}

.noticeToMembersListDetail>p{
    position:absolute;
    left:0;
    top:50%;
    transform:translateY(-50%);
    padding:0 25px;
    font-size:18px;
    color:#333;
    line-height:30px;


}

.noticeToMembersLeftList li:nth-child(even) {
    background:rgba(248,248,248,1);
    box-shadow:0px 2px 4px 0px rgba(179,179,179,0.5);
}


.noticeToMembersLeftList li:nth-child(odd) {
    background:rgba(255,255,255,1);
    box-shadow:-1px 0px 4px 0px rgba(166,166,166,0.5);
}

.noticeToMembersRightList  li:nth-child(even) {
    background:rgba(255,255,255,1);
    box-shadow:-1px 0px 4px 0px rgba(166,166,166,0.5);
}


.noticeToMembersRightList li:nth-child(odd) {
    background:rgba(248,248,248,1);
    box-shadow:0px 2px 4px 0px rgba(179,179,179,0.5);
}
.noticeToMembersMiddleList li:nth-child(even) {
    background:rgba(248,248,248,1);
    box-shadow:0px 2px 4px 0px rgba(179,179,179,0.5);
}


.noticeToMembersMiddleList li:nth-child(odd) {
    background:rgba(255,255,255,1);
    box-shadow:-1px 0px 4px 0px rgba(166,166,166,0.5);
}


.accesToServices h2 {
    text-align: center;
    color:#333;
    font-size:26px;
    margin-bottom:20px;
}
.accesToServices {
    padding:35px 60px;

    background:rgba(247,247,247,1);
    margin-top:10px;

}
.accesToServices>p {
    color:#333;
    font-size:18px;
    line-height: 30px;
}



</style>



// WEBPACK FOOTER //
// src/components/associationIntroduce.vue